import { isValidIp, removeLeadingZerosFromIpOctets } from '../ip/ip';

export type IpValidationResults = {
  duplicate: { [key: string]: Set<string> };
  invalid: Set<string>;
  valid: Set<string>;
};

type ValidateIpAddressesConfig = {
  existingEntries?: string[];
  restrictedAddresses?: Array<string>;
};

type ValidateIpAddresses = (
  ipAddresses: string[],
  options?: Partial<ValidateIpAddressesConfig>,
) => IpValidationResults;

export const validateIpAddresses: ValidateIpAddresses = (
  ipAddresses,
  { existingEntries, restrictedAddresses } = {},
) => {
  const validationResults: IpValidationResults = {
    duplicate: {},
    invalid: new Set(),
    valid: new Set(),
  };

  const tempValid: string[][] = [];

  ipAddresses.forEach((ip) => {
    if (!isValidIp(ip)) {
      validationResults.invalid.add(ip);
      return;
    }

    const trimmedIp = removeLeadingZerosFromIpOctets(ip);

    if (
      restrictedAddresses?.length &&
      restrictedAddresses.includes(trimmedIp)
    ) {
      validationResults.invalid.add(ip);
      return;
    }

    tempValid.push([ip, trimmedIp]);
  });

  tempValid.forEach(([ip, trimmedIp]) => {
    const isDuplicate =
      validationResults.valid.has(trimmedIp) ||
      existingEntries?.find((i) => i === ip || i === trimmedIp);

    if (isDuplicate) {
      if (validationResults.duplicate[trimmedIp] instanceof Set) {
        validationResults.duplicate[trimmedIp].add(ip);
      } else {
        validationResults.duplicate[trimmedIp] = new Set([ip]);
      }
      return;
    }

    validationResults.valid.add(trimmedIp);
  });

  return validationResults;
};
